<template>
  <div class="report-metric-strip">
    <div
      v-if="groupTitles.length"
      class="row report-metric-strip__titles"
    >
      <div
        v-for="(t, idx) in groupTitles"
        :key="`title-${idx}`"
        class="col-6"
      >
        <p class="report-metric-strip__group-title">
          {{ t }}
        </p>
      </div>
    </div>
    <div class="row g-3 report-metric-strip__cards">
      <div
        v-for="card in cards"
        :key="card.key"
        :class="cardColClass"
      >
        <ReportMetricCalloutCard
          :value="card.value"
          :suffix="card.suffix != null ? card.suffix : suffix"
          :label="card.label"
        >
          <template
            v-if="card.subText || $slots.cardSub"
            #sub
          >
            <slot
              name="cardSub"
              :card="card"
            >
              {{ card.subText }}
            </slot>
          </template>
        </ReportMetricCalloutCard>
      </div>
    </div>
  </div>
</template>

<script>
import ReportMetricCalloutCard from './ReportMetricCalloutCard.vue';

export default {
  name: 'ReportMetricCalloutStrip',
  components: { ReportMetricCalloutCard },
  props: {
    cards: {
      type: Array,
      default() {
        return [];
      },
    },
    groupTitles: {
      type: Array,
      default() {
        return [];
      },
    },
    suffix: {
      type: String,
      default: '',
    },
    /** Bootstrap col class for each card, e.g. col-md-3 */
    cardColClass: {
      type: String,
      default: 'col-md-3',
    },
  },
};
</script>

<style scoped>
.report-metric-strip__titles {
  margin-bottom: 1rem;
}

.report-metric-strip__group-title {
  font-family: Roobert-Semi-Bold, Roobert-Regular, 'Segoe UI', Arial, sans-serif !important;
  font-weight: 600 !important;
  font-size: 24px !important;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0 !important;
  padding-bottom: 0;
  position: relative;
  top: 12px;
  color: #31333f;
}

.report-metric-strip__cards {
  align-items: stretch;
}

.report-metric-strip__cards > [class*='col'] {
  display: flex;
}
</style>
